import React from 'react';
import MaskedDateInput, { IMaskedDateInputProps } from '../MaskedDateInput';
import { useWorkCalendar } from '../../hooks/useWorkCalendar';
import { toLocalDate } from '../../lib/toLocalDate';

export type IDateFieldProps = Omit<IMaskedDateInputProps, 'data-testid'> & {
    /** Выходные — по рабочему календарю (`loadWorkCalendar` из `UiProvider`); без него — суббота и воскресенье */
    workCalendar?: boolean;
    testid?: string;
};

const DateField: React.FC<IDateFieldProps> = ({ workCalendar, testid, excludeDate, ...rest }) => {
    const calendar = useWorkCalendar(!!workCalendar);
    // Mantine отдаёт excludeDate ISO "YYYY-MM-DD". new Date("YYYY-MM-DD") парсит как
    // UTC midnight → в локальном TZ сдвиг. useWorkCalendar строит массивы через
    // local midnight, isDateInArray сравнивает по getTime() строго — toLocalDate
    // выравнивает, иначе переносы рабочих/выходных не попадают в excludeDate.
    const isExcluded =
        workCalendar && !excludeDate ? (dateStr: string) => calendar.isHoliday(toLocalDate(dateStr)) : excludeDate;

    return (
        <MaskedDateInput {...rest} excludeDate={isExcluded} data-testid={testid ? `date-field-${testid}` : undefined} />
    );
};

export default DateField;
